import React, { Fragment } from 'react'

import { faCreditCard, faPlus } from '@fortawesome/pro-light-svg-icons'

import { CreditCard } from '@infura/packages.api'
import { ActionLink } from '@infura/packages.ui/ActionLink'
import { Empty } from '@infura/packages.ui/Empty'
import { Loader } from '@infura/packages.ui/Loader'
import { Text } from '@infura/packages.ui/Text'

import { ActiveCard } from 'components/billing/ActiveCard'

import { getCardBrand, getCardExpiration, getCardHolderName, getSlicedCardNumber } from 'lib/utils/billing'

type CardInfoProps = {
  creditCard?: CreditCard
  loading: boolean
  togglePaymentForm: () => void
  sectionTitle?: string
}

export const CardInfo = ({ creditCard, loading, sectionTitle, togglePaymentForm }: CardInfoProps) => {
  if (loading) {
    return (
      <Fragment>
        <Loader className='w-18 mb-4 h-6' pulse />
        <Loader className='h-20 w-full pb-0.5' pulse />
      </Fragment>
    )
  }

  return !!creditCard ? (
    <ActiveCard
      description={
        <>
          <Text className='mr-6' data-testid='billing-card-details'>
            {getCardBrand(creditCard)} ending in {getSlicedCardNumber(creditCard)}
          </Text>
          <Text data-testid='billing-card-expiration'>{getCardExpiration(creditCard)}</Text>
        </>
      }
      icon={faCreditCard}
      onClick={togglePaymentForm}
      sectionTitle={sectionTitle}
      title={getCardHolderName(creditCard) ?? ''}
    />
  ) : (
    <Empty data-testid='billing-no-card-info' icon='file' title='No card info added'>
      <>
        <Text>To unlock premium features and complete transactions, please add your card info.</Text>
        <ActionLink
          className='py-2'
          data-testid='billing-add-card-info'
          icon={faPlus}
          iconPosition='left'
          onClick={togglePaymentForm}
        >
          Add card info
        </ActionLink>
      </>
    </Empty>
  )
}
